import { WidgetI18nProvider } from '@elfsight/widget-i18n';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider, WidgetRectProvider } from '@elfsight/widget-utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useSettings } from '@wu/widget-core';
import DICTIONARY from '../language/dictionary.json';
import { meta } from './meta';
import { PreviewViewToggle } from './widget/components';
import { AnimationProvider, VoteProvider } from './widget/providers';
import { Widget } from './widget/widget';

const queryClient = new QueryClient();

export function Poll() {
  const {
    customCSS,
    customJS,
    editMode,
    renderThumbnailMode,
    font,
    language,
    widgetId = 'test-widget-id'
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);
  useFontsLoader([font]);

  return (
    <QueryClientProvider client={queryClient}>
      <StorageProvider widgetId={widgetId} name={meta.name}>
        <VoteProvider>
          <WidgetRectProvider>
            <AnimationProvider>
              <CustomCSS
                customCSS={customCSS}
                prefixClassName={customCSSPrefixClassName}
              />

              <WidgetI18nProvider
                dictionary={DICTIONARY}
                language={language?.language ?? 'en'}
                override={language?.messages ?? {}}
              >
                <PreviewViewToggle />

                <EmbedRoot
                  customCSSClassName={customCSSPrefixClassName}
                  width={640}
                  font={font}
                >
                  <Widget />
                </EmbedRoot>
              </WidgetI18nProvider>
            </AnimationProvider>
          </WidgetRectProvider>
        </VoteProvider>
      </StorageProvider>
    </QueryClientProvider>
  );
}
